module.exports = __webpack_public_path__ + "static/img/03_07_rotary.ef48938.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/03_07_rotary.png
// module id = a4z1
// module chunks = 12